import React from 'react'
import TopNavBar from '../common/Header/TopNavBar'
import Footer from '../common/Footer/Footer'
import BannerSlide from '../Sections/BannerSlides'
// import ChatBox from '../common/ChatBox'

function ContactPage() {
  return (
    <div className='contt-con'>
        <TopNavBar />
        <BannerSlide />
        <div className=''>
        <div className='con-con mx-5'>
        <div className='mx-5 justify-content-center '>
        <h1 className='text-center'>Contact Us</h1>
  <p className='text-center'>We'd love to hear from you! Please use the form below to get in touch.</p>
  
  <form action="#" method="post"  >
    <div className="form-group">
      <label htmlFor="name">Name</label>
      <input type="text" id="name" name="name" className="form-control " required/>
    </div>
    <div className="form-group">
      <label htmlFor="email">Email</label>
      <input type="email" id="email" name="email" className="form-control " required />
    </div>
    <div className="form-group">
      <label htmlFor="message">Message</label>
      <textarea id="message" name="message" className="form-control cmt" rows="5" required></textarea>
    </div>
    <div className='d-flex flex-column align-items-center'>
    <button type="submit" className="btn btn-primary m-3">Submit</button>

    </div>
  </form>
  </div>
  </div>
  {/* <div className='col-3 query'> 
   <ChatBox />
</div> */}
</div>
        <Footer />
    </div>
  )
}

export default ContactPage